<template>
  <div>
    <BreadCrumd
      :title="'Gestion des budgets'"
      :description="'Nouveau budget'"
    />
    <div class="mt-4 mb-4">
      <form @submit.prevent="submit" @keydown="form.onKeydown($event)">
        <alert-error
          v-if="form.errors.get('message')"
          :form="form"
          :message="form.errors.get('message')"
        ></alert-error>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mb-n2">
                <div class="row d-flex justify-content-center">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="version"
                        >Version <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{
                          'is-invalid': form.errors.has('version'),
                        }"
                        id="version"
                        v-model="form.version"
                        type="text"
                        placeholder="Version"
                        maxlength="50"
                        required
                      />
                      <has-error :form="form" field="version"></has-error>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="centre_cout"
                        >Centre de coût
                        <span class="text-danger">*</span></label
                      >
                      <v-custom-select
                        label="nom"
                        :options="centreCouts"
                        :reduce="(centreCout) => centreCout.uuid"
                        v-model="form.centre_cout"
                        placeholder="Centre de coût"
                      >
                        <template v-slot:option="{ nom }">
                          <h5 style="margin: 0">{{ nom }}</h5>
                        </template>
                        <template #no-options> Aucune donnée </template>
                        <template #search="{ attributes, events }">
                          <input
                            id="centre_cout"
                            class="custom-select-height vs__search"
                            v-bind="attributes"
                            v-on="events"
                          />
                        </template>
                      </v-custom-select>
                      <div>
                        <input
                          type="hidden"
                          class="form-control"
                          :class="{
                            'is-invalid': form.errors.has('centre_cout'),
                          }"
                        />
                        <has-error :form="form" field="centre_cout"></has-error>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="annee"
                        >Année <span class="text-danger">*</span></label
                      >
                      <input
                        class="form-control"
                        :class="{ 'is-invalid': form.errors.has('annee') }"
                        id="annee"
                        v-model="form.annee"
                        type="text"
                        placeholder="Année"
                        maxlength="4"
                        required
                      />
                      <has-error :form="form" field="annee"></has-error>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-n4">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body mt-n2 mb-n2">
                <div class="row mt-n2 d-flex justify-content-center">
                  <div class="col-md-6">
                    <cool-select
                      v-model="selectedLigne"
                      :items="ligneBudgetaires"
                      item-text="nom"
                      placeholder="Recherche ligne budgétaire"
                      disable-filtering-by-search
                      @select="onSelectedLigne"
                      :search-text.sync="searchText"
                    >
                      <template #no-data>
                        {{
                          ligneBudgetaires.length > 0
                            ? 'Aucun resultat.'
                            : '2 caratères pour lancer la recherche.'
                        }}
                      </template>
                      <template #item="{ item }">
                        <div class="item">
                          <div>
                            <h5>{{ item.nom }}</h5>
                          </div>
                        </div>
                      </template>
                    </cool-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <b-alert
          :show="itemListErrorMessage !== null"
          dismissible
          variant="danger"
        >
          <span v-html="itemListErrorMessage"></span>
        </b-alert>
        <div class="row mt-n4">
          <div class="col-md-12 zui-wrapper">
            <div class="zui-scroll">
              <table
                class="card table table-sm table-striped table-condensed zui-table"
              >
                <thead>
                  <tr>
                    <th style="width: 400px">Lignes budgétairess</th>
                    <th class="text-center" style="width: 150px">Janvier</th>
                    <th class="text-center" style="width: 150px">Février</th>
                    <th class="text-center" style="width: 150px">Mars</th>
                    <th class="text-center" style="width: 150px">Avril</th>
                    <th class="text-center" style="width: 150px">Mai</th>
                    <th class="text-center" style="width: 150px">Juin</th>
                    <th class="text-center" style="width: 150px">Juillet</th>
                    <th class="text-center" style="width: 150px">Août</th>
                    <th class="text-center" style="width: 150px">Septembre</th>
                    <th class="text-center" style="width: 150px">Octobre</th>
                    <th class="text-center" style="width: 150px">Novembre</th>
                    <th class="text-center" style="width: 150px">Décembre</th>
                    <th class="text-center" style="width: 300px">Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in form.item_lists" :key="index">
                    <td
                      style="vertical-align: middle; width: 400px"
                      class="d-flex justify-content-between"
                    >
                      <div>
                        {{ item.nom }}
                      </div>
                      <div>
                        <a
                          class="cursor-pointer"
                          @click.prevent="removeItem(index)"
                        >
                          <i class="fa fa-trash font-size-17 text-danger"></i
                        ></a>
                      </div>
                    </td>

                    <td
                      class="text-center"
                      style="vertical-align: middle; width: 150px"
                    >
                      <input
                        class="form-control"
                        v-model.number="item.p1"
                        type="text"
                        placeholder="Montant"
                        @focus="$event.target.select()"
                      />
                    </td>

                    <td
                      class="text-center"
                      style="vertical-align: middle; width: 150px"
                    >
                      <input
                        class="form-control"
                        v-model.number="item.p2"
                        type="text"
                        placeholder="Montant"
                        @focus="$event.target.select()"
                      />
                    </td>

                    <td
                      class="text-center"
                      style="vertical-align: middle; width: 150px"
                    >
                      <input
                        class="form-control"
                        v-model.number="item.p3"
                        type="text"
                        placeholder="Montant"
                        @focus="$event.target.select()"
                      />
                    </td>

                    <td
                      class="text-center"
                      style="vertical-align: middle; width: 150px"
                    >
                      <input
                        class="form-control"
                        v-model.number="item.p4"
                        type="text"
                        placeholder="Montant"
                        @focus="$event.target.select()"
                      />
                    </td>
                    <td
                      class="text-center"
                      style="vertical-align: middle; width: 150px"
                    >
                      <input
                        class="form-control"
                        v-model.number="item.p5"
                        type="text"
                        placeholder="Montant"
                        @focus="$event.target.select()"
                      />
                    </td>
                    <td
                      class="text-center"
                      style="vertical-align: middle; width: 150px"
                    >
                      <input
                        class="form-control"
                        v-model.number="item.p6"
                        type="text"
                        placeholder="Montant"
                        @focus="$event.target.select()"
                      />
                    </td>
                    <td
                      class="text-center"
                      style="vertical-align: middle; width: 150px"
                    >
                      <input
                        class="form-control"
                        v-model.number="item.p7"
                        type="text"
                        placeholder="Montant"
                        @focus="$event.target.select()"
                      />
                    </td>
                    <td
                      class="text-center"
                      style="vertical-align: middle; width: 150px"
                    >
                      <input
                        class="form-control"
                        v-model.number="item.p8"
                        type="text"
                        placeholder="Montant"
                        @focus="$event.target.select()"
                      />
                    </td>
                    <td
                      class="text-center"
                      style="vertical-align: middle; width: 150px"
                    >
                      <input
                        class="form-control"
                        v-model.number="item.p9"
                        type="text"
                        placeholder="Montant"
                        @focus="$event.target.select()"
                      />
                    </td>
                    <td
                      class="text-center"
                      style="vertical-align: middle; width: 150px"
                    >
                      <input
                        class="form-control"
                        v-model.number="item.p10"
                        type="text"
                        placeholder="Montant"
                        @focus="$event.target.select()"
                      />
                    </td>
                    <td
                      class="text-center"
                      style="vertical-align: middle; width: 150px"
                    >
                      <input
                        class="form-control"
                        v-model.number="item.p11"
                        type="text"
                        placeholder="Montant"
                        @focus="$event.target.select()"
                      />
                    </td>
                    <td
                      class="text-center"
                      style="vertical-align: middle; width: 150px"
                    >
                      <input
                        class="form-control"
                        v-model.number="item.p12"
                        type="text"
                        placeholder="Montant"
                        @focus="$event.target.select()"
                      />
                    </td>
                    <td
                      class="text-right font-weight-bold"
                      style="vertical-align: middle; width: 300px"
                    >
                      {{ total(item) | currency }}
                    </td>
                  </tr>
                  <tr
                    v-if="form.item_lists.length > 0"
                    class="d-flex font-size-17"
                  >
                    <td
                      colspan="13"
                      class="text-center font-weight-bold"
                      style="width: 2200px"
                    >
                      TOTAL
                    </td>
                    <td
                      class="text-right font-weight-bold"
                      style="width: 300px"
                    >
                      {{ gTotal() | currency }}
                    </td>
                  </tr>
                  <tr v-if="form.item_lists.length === 0" class="d-flex">
                    <td colspan="14" class="text-center col-12">
                      Aucune donnée
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="row mb-4 mt-4">
          <div class="col-md-12 text-right">
            <button
              type="button"
              class="btn btn-secondary mr-4"
              @click.prevent="$router.push({ name: 'budget' }).catch(() => {})"
            >
              Liste des budgets
            </button>

            <ButtonLoader
              :busy="form.busy"
              type="submit"
              customClass="btn btn-custom-primary w-40"
              loadText="Traitement en cours..."
              Text="Créer"
              style="min-width: 100px"
            ></ButtonLoader>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import URL from '@/http/achat/budget';
import Form from 'vform';
import { CoolSelect } from 'vue-cool-select';
export default {
  data() {
    return {
      form: new Form({
        annee: '',
        centre_cout: '',
        version: '',
        item_lists: [],
      }),
      centreCouts: [],
      ligneBudgetaires: [],
      selectedLigne: null,
      searchText: null,
      itemListErrorMessage: null,
      cloneId: null,
      title: 'Gestion des budgets - Création',
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  watch: {
    $route() {
      this.init();
    },
  },
  components: {
    CoolSelect,
  },
  methods: {
    gTotal() {
      let total = 0;
      this.form.item_lists.map((item) => {
        total += this.total(item);
      });
      return total;
    },
    total(item) {
      return (
        Number(item.p1) +
        Number(item.p2) +
        Number(item.p3) +
        Number(item.p4) +
        Number(item.p5) +
        Number(item.p6) +
        Number(item.p7) +
        Number(item.p8) +
        Number(item.p9) +
        Number(item.p10) +
        Number(item.p11) +
        Number(item.p12)
      );
    },
    removeItem: function (index) {
      this.form.item_lists.splice(index, 1);
    },
    onSelectedLigne: function (select) {
      if (select) {
        var objExiste = window._.find(
          this.form.item_lists,
          (o) => o.uuid === select.uuid
        );
        if (!objExiste) {
          this.form.item_lists.push({
            uuid: select.uuid,
            nom: select.nom,
            p1: 0,
            p2: 0,
            p3: 0,
            p4: 0,
            p5: 0,
            p6: 0,
            p7: 0,
            p8: 0,
            p9: 0,
            p10: 0,
            p11: 0,
            p12: 0,
          });
        }

        this.searchText = null;
        this.selectedLigne = null;
      }
    },
    init() {
      this.centreCouts = [];
      this.ligneBudgetaires = [];

      if (this.$route.params.cloneId) {
        this.cloneId = this.$route.params.cloneId;

        window.axios
          .all([
            window.axios.get(URL.GET_REQUIREMENTS),
            window.axios.get(URL.BUDGET + '/' + this.cloneId, {
              params: {
                edit: true,
              },
            }),
          ])
          .then(
            window.axios.spread((resp1, resp2) => {
              this.centreCouts = resp1.data.centre_couts;
              this.ligneBudgetaires = resp1.data.ligne_budgetaires;
              Object.assign(this.form, resp2.data.budget);
              this.form.item_lists = this.form.item_lists.map((item) => {
                return {
                  uuid: item.uuid,
                  nom: item.nom,
                  p1: item.p1,
                  p2: item.p2,
                  p3: item.p3,
                  p4: item.p4,
                  p5: item.p5,
                  p6: item.p6,
                  p7: item.p7,
                  p8: item.p8,
                  p9: item.p9,
                  p10: item.p10,
                  p11: item.p11,
                  p12: item.p12,
                };
              });
            })
          )
          .catch();
      } else {
        window.axios
          .get(URL.GET_REQUIREMENTS)
          .then((resp) => {
            this.centreCouts = resp.data.centre_couts;
            this.ligneBudgetaires = resp.data.ligne_budgetaires;
          })
          .catch();
      }
    },
    submit() {
      this.itemListErrorMessage = null;
      this.form
        .post(URL.BUDGET)
        .then((resp) => {
          this.showSimpleAlerte('top-end', 'success', resp.data.message);
          this.form.reset();
          if (this.cloneId) {
            this.cloneId = null;
          }
          this.$router.push({
            name: 'budget-show',
            params: { id: resp.data.budget.id },
          });
        })
        .catch((err) => {
          window._.forEach(err.response.data.errors, (value, key) => {
            if (key.includes('item_lists')) {
              this.itemListErrorMessage = value[0];
            } else {
              this.form.errors.set('message', err.response.data.message);
            }
            return 0;
          });
        });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped>
.zui-wrapper {
  position: relative;
}
.zui-scroll {
  overflow-x: scroll;
  overflow-y: visible;
  padding-bottom: 5px;
}
.zui-table {
  left: 0;
  top: auto;
  width: 2400px;
}
</style>
